var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.43555,
    y: 10.6211,
    width: 7.33455,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(-45 5.43555 10.6211)",
    fill: "#272932"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.37793,
    y: 5.43555,
    width: 7.33552,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(45 6.37793 5.43555)",
    fill: "#272932"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close_small.fe0b5427e95a8d58ff182d8debe37984.svg";
export { ForwardRef as ReactComponent };